export default __webpack_public_path__ + "static/media/mine-spil.47d89504.svg";